import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { FetchParam } from "app/services/fetchService";

import { sitesOptions } from "../queries/sitesQueries";
import type { IWebsitesFavicons, IWebsitesFaviconsQueryOptions } from "../types";

export const useWebsitesFavicons = (
    websites: string[],
    params?: FetchParam,
    options?: IWebsitesFaviconsQueryOptions,
): UseQueryResult<IWebsitesFavicons> => {
    return useQuery({
        ...sitesOptions.websitesFavicons(websites, params, options),
    });
};
